import script from "./DataTableMixin.vue?vue&type=script&lang=ts"
export * from "./DataTableMixin.vue?vue&type=script&lang=ts"

export default script